export const ErrorResponse = {

  ERROR_401_MESSAGE:'Your session has expired. Please login again to continue.',
}